<div class="container-fluid border py-4">
    <div class="row">
        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-between align-items-between h-100">
                <div class="">
                    <h3 class="pt-4"><i>PRINCIPLES OF EQUITABLE BEHAVIOR</i></h3>
                    <span class="footnote">Self-assessment Results</span>
                    <div class="pt-5 px-0 col-12 col-lg-9">
                        <div class="text-xlarge pt-4" *ngIf="resultTitle">You are a <b>{{resultTitle}}</b> practitioner
                            of
                            Principles of Equitable Behavior!</div>
                        <div class="py-4" *ngIf="resultText" [innerHtml]="resultText"></div>
                    </div>
                </div>
                <div class="">
                    <div class="pb-3">From <span class="text-blue">Principles of Equitable Behavior course.</span></div>
                    <a role="button" class="btn btn-primary" (click)="onViewFullResults()">view full results</a>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div *ngIf="answers && answers.length > 0">
                <flower [answers]="answers" [mode]="'results'"></flower>
            </div>
        </div>
    </div>
</div>